import { useField, useForm } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { DateTimeInput, DateTimeInputProps } from './DateTimeInput'

export type DateTimeInputFieldProps = Omit<DateTimeInputProps, 'value' | 'onChange'> & {
  name: string
  validate?: FieldValidator<Date>
  onChange?: (value: Date | null) => void
}

export function DateTimeInputField({ name, validate, onChange, ...props }: DateTimeInputFieldProps) {
  const form = useForm()
  const { input, meta } = useField<Date>(name, { validate })

  const errorMessage = meta.error || meta.submitError || props.error

  return (
    <DateTimeInput
      {...input}
      onChange={(value) => {
        form.change(name, value)
        onChange?.(value)
      }}
      {...props}
      error={Boolean(meta.touched && errorMessage)}
      formHelperText={(meta.touched && errorMessage) || undefined}
    />
  )
}
